import { keysToCamelCase } from '@hotjar/insights-common/lib/convert-string/toCamelCase';
import type { PermissionsResponse, PermissionsResponseDto } from './types';

export const permissionsResponseDtoToModel = (
  response: PermissionsResponseDto,
): PermissionsResponse => keysToCamelCase(response);
